const selectFamilies = state => state.data.families

const FamilyDataStoreSelectors = {
  families: selectFamilies
}

export default FamilyDataStoreSelectors
